<template>
  <div class="checkList_box_wrap">
    <!-- 运费明细 -->
    <vxe-toolbar
      id="toolbarId_ca8"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="checkList_search_btn" @click="funcFilter()">
          查询
        </el-button>
        <!-- <el-button @click="funcExport()" v-if="checkListTotal_export">
          全部导出
        </el-button> -->
      </template>
    </vxe-toolbar>
    <!-- <div class="checkList_total">
      合计实付总金额:
      <span style="color:red;">{{ shipmentActualFreightTotal || "--" }}元</span>
    </div> -->
    <!-- table表格
      @sort-change="sortList"
      :footer-method="footerMethod"
      :loading="loading"
    -->
    <vxe-table
      ref="xTable"
      :data="tableData"
      :loading="loading"
      resizable
      stripe
      highlight-current-row
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="90%"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :footer-method="footerMethod"
    >
      <vxe-table-column>
        <vxe-table-column
          field="orderDetailNumber"
          title="运单单号"
          fixed="left"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderDetailNumber"
            placeholder="请输入运单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 运费类型 -->
      <vxe-table-column>
        <vxe-table-column
          field="isPayAdvance"
          title="运费类型"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isPayAdvance')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isPayAdvance"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in isPayAdvanceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <!-- 金额（元） -->
      <vxe-table-column>
        <vxe-table-column
          field="amount"
          title="金额（元）"
          width="190"
          align="center"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.amountStart"
                style="padding-right:0px!important;"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.amountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerName"
          title="付款方名称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerName"
            placeholder="请输入付款方名称"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="payerAccount"
          title="付款方账号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerAccount"
            placeholder="请输入付款方账号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerPhone"
          title="付款方电话"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payerPhone"
            placeholder="请输入付款方电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payerRole"
          title="付款方角色"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'payerRole')
          "
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.payerRole"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in payerRoleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeName"
          title="收款方名称"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeName"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeAccount"
          title="收款方账号"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeeAccount"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeePhone"
          title="收款方电话"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.payeePhone"
            type="number"
            placeholder="请输入"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payeeRole"
          title="收款方角色"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'payeeRole')
          "
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.payeeRole"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in payeeRoleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payType"
          title="支付类型"
          min-width="130"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'payType')
          "
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.payType" placeholder="请选择" clearable>
            <el-option
              v-for="item in payTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bizNo"
          title="流水批次号"
          min-width="180"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bizNo"
            placeholder="请输入流水批次号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="callbackTime"
          title="完成时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.callbackTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'callbackTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="modifiedByName"
          title="操作人员"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入操作人员"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- 操作 -->
      <vxe-table-column title="操作" width="160px" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="查看详情"
            placement="top"
          >
            <!-- <vxe-button type="text" @click="funcEdit(scope.row.code,true)">
              <em class="el-icon-document" />
            </vxe-button> -->
            <vxe-button
              type="text"
              @click="orderDesil(scope.row.orderDetailCode)"
            >
              <em class="el-icon-document"
            /></vxe-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="查看银行凭证"
            placement="top"
          >
            <vxe-button type="text" @click="lookReceipt(scope.row)">
              <em class="el-icon-paperclip" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <!-- 分页 -->
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1000"
      height="80%"
      resize
    >
      <ordergoods ref="detailRef" />
    </vxe-modal>
    <!-- etc发票详情弹窗 -->
    <vxe-modal
      v-model="showDetail"
      title="ect发票详情"
      width="1070"
      height="600"
      resize
    >
      <checkDetail />
    </vxe-modal>
    <downloadData ref="downloadRef" />
    <vxe-modal
      v-model="receiptPreviewVisible"
      width="1200"
      height="80%"
      title="详情"
      resize
      :transfer="true"
    >
      <MultifilePreview v-if="receiptPreviewVisible" :pdf-urls="pdfUrls" />
    </vxe-modal>
  </div>
</template>

<script>
import ordergoods from "@/components/WaybillDetails";
import MultifilePreview from "@/components/MultifilePreview/index.vue";
import { getLimit } from "@/utils/getLimit.js";
import checkDetail from "./components/checkDetail.vue";
import {
  settlementlistnew,
  settlementlistExport,
  queryListForPlatformToDrive
} from "@/api/category";
import { electronicReceipt } from "@/api/InternetBanking";
export default {
  components: {
    checkDetail,
    ordergoods,
    MultifilePreview
  },
  data() {
    return {
      receiptPreviewVisible: false,
      pdfUrls: "",
      tuteship: false,
      payTypeOptions: [
        { label: "油点支付", value: 1 },
        { label: "转账支付", value: 3 },
        { label: "网商余额", value: 4 },
        { label: "网商合并", value: 5 },
        { label: "车队分账", value: 6 },
        { label: "凭证支付", value: 9 },
        { label: "银行支付", value: 10 },
        { label: "在线支付", value: 11 }
      ],
      isPayAdvanceOptions: [
        { label: "到付运费", value: 0 },
        { label: "预付运费", value: 1 },
        { label: "回单运费", value: 2 }
      ],
      paidLineTypeOptions: [
        {
          label: "在线支付",
          value: 0,
          color: "gray"
        },
        {
          label: "转账支付",
          value: 1,
          color: "#0000ff"
        }
      ],
      payeeRoleOptions: [
        { label: "平台", value: 0 },
        { label: "个体托运人", value: 1 },
        { label: "企业托运人", value: 2 },
        { label: "个体实际承运人", value: 3 },
        { label: "车队", value: 4 }
      ],
      payerRoleOptions: [
        { label: "平台", value: 0 },
        { label: "个体托运人", value: 1 },
        { label: "企业托运人", value: 2 }
      ],
      invoiceStatusList: [
        { label: "申请开票", value: "0" },
        { label: "已开票", value: "1" },
        { label: "已取消", value: "2" },
        { label: "确认收票", value: "3" },
        { label: "开票中", value: "4" },
        { label: "开票失败", value: "5" },
        { label: "红冲中", value: "6" },
        { label: "已红冲", value: "7" },
        { label: "红冲待确认", value: "8" }
      ],
      shipmentActualFreightTotal: null,
      exportObj: {
        exportUrl: `/ntocc-tms-api/orderDetail/settlementlistnewExport`, //导出接口
        name: "结算清单总表",
        methods: true
      },
      checkList_export: false,
      checkList_search_btn: false,
      checkListTotal_export: false,
      listQuery: {
        orderDetailNumber: "",
        isPayAdvance: null,
        amountStart: "",
        amountEnd: "",
        payerName: "",
        payerAccount: "",
        payerPhone: "",
        payerRole: null,
        payeeName: "",
        payeeAccount: "",
        payeePhone: "",
        payeeRole: null,
        payType: null,
        bizNo: "",
        callbackTime: "",
        callbackTimeStart: "",
        callbackTimeEnd: "",
        modifiedByName: "",
        payStatus: null,
        invoiceStatus: null,
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      Pagingconf: [],
      paymentStatusOptions: [
        { value: "0", label: "处理中" },
        { value: "1", label: "已支付" },
        { value: "2", label: "支付失败" },
        { value: "99", label: "未支付" } //TODO:"99"处理不显示清除icon的问题
      ],
      preOptions: [
        { value: 0, label: "到付运费" },
        { value: 1, label: "预付运费" },
        { value: 2, label: "回单运费" }
      ],
      invoiceStatusOptions: [
        { value: "0", label: "申请开票" },
        { value: "1", label: "已开票" },
        { value: "2", label: "已取消" },
        { value: "99", label: "待申请" } //TODO:"99"处理不显示清除icon的问题
      ],
      etcInvoiceStatusOptions: [
        { value: "未开票", label: "未开票" },
        { value: "已开票", label: "已开票" }
      ],
      tableData: [],
      showDetail: false,
      loading: false,
      optionsPicker: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  created() {
    this.checkList_export = getLimit("checkList_export");
    this.checkList_search_btn = getLimit("checkList_search_btn");
    this.checkListTotal_export = getLimit("checkListTotal_export");
    this.findList();
  },
  mounted() {},
  methods: {
    lookReceipt(row) {
      if (row.code) {
        electronicReceipt({ code: row.code }).then(res => {
          const url = res.data;
          if (url) {
            this.pdfUrls = url;
            this.receiptPreviewVisible = true;
          } else {
            return this.$message({ message: "暂无回单", type: "warning" });
          }
        });
      } else {
        return this.$message({ message: "暂无回单", type: "warning" });
      }
    },
    orderDesil(c) {
      this.$refs.detailRef.Getdetails(c);
      this.tuteship = true;
    },
    formatterField({ cellValue }, prefix) {
      const item = this[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterInvoiceStatus({ cellValue }) {
      const item = this.invoiceStatusList.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterServicePAy(row) {
      console.log(row.row.isPayAdvance);
      if (row.row.isPayAdvance == 0) {
        return row.row.taxPayFee;
      } else if (row.row.isPayAdvance == 1) {
        return "--";
      } else if (row.row.isPayAdvance == 2) {
        return row.row.returnTaxFee;
      }
    },

    formatterPayType(row) {
      console.log("formatterPayType================", row);
      switch (row.row.isPayAdvance) {
        case 0:
          return "到付运费";
        case 1:
          return "预付运费";
        case 2:
          return "回单运费";
      }
    },
    async getSettlementlistExport() {
      let res = await settlementlistExport(this.listQuery);
      console.log("getSettlementlistExport===", res);
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "shipmentActualFreight") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "taxPayFee") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "totalAmountAll") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "totalTaxAmountAll") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "driverActualFreight") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "weight") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    },
    clearPayStatus() {
      this.listQuery.payStatus = null;
    },
    clearInvoiceStatus() {
      this.listQuery.invoiceStatus = null;
    },
    getInvoiceStatus(state) {
      switch (state) {
        case "0":
          return "申请开票";
        case "1":
          return "已开票";
        case "2":
          return "已取消";
        case "3":
          return "确认收票";
        case "4":
          return "开票中";
        case "5":
          return "开票失败";
        case "6":
          return "红冲中";
        case "7":
          return "已红冲";
        case "8":
          return "红冲待确认";
        default:
          return "未开票";
      }
    },
    getEtcType(type) {
      switch (type) {
        case "0":
          return "未推送";
        case "1":
          return "已推送";
        case "2":
          return "推送完成";
        case "5":
          return "分单已推送";
        default:
          return "--";
      }
    },
    getPayState(state) {
      switch (state) {
        case "0":
          return "处理中";
        case "1":
          return "已支付";
        case "2":
          return "支付失败";
        default:
          return "未支付";
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        // let data = { ...this.listQuery, weight: +this.listQuery.weight };
        // if (this.listQuery.payTime) {
        //   data.payTimeStart = this.listQuery.payTime[0];
        //   data.payTimeEnd = this.listQuery.payTime[1];
        //   delete data.payTime;
        // }
        // if (this.listQuery.invoiceIssuedTime) {
        //   data.invoiceIssuedTimeStart = this.listQuery.invoiceIssuedTime[0];
        //   data.invoiceIssuedTimeEnd = this.listQuery.invoiceIssuedTime[1];
        //   delete data.invoiceIssuedTime;
        // }
        // if (data.payStatus === "99") {
        //   data.payStatus = "";
        // }
        // if (data.invoiceStatus === "99") {
        //   data.invoiceStatus = "";
        // }
        let data = {
          ...this.listQuery
        };
        delete data.callbackTime;
        queryListForPlatformToDrive(data).then(response => {
          this.loading = false;

          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;

          // this.shipmentActualFreightTotal =
          //   response.data.sumObject.shipmentActualFreight;
          this.tableData.forEach(item => {
            item.invoiceStatus = this.getInvoiceStatus(item.invoiceStatus);
            item.EtcYDcode = Array.isArray(item.etcInvoiceList)
              ? item.etcInvoiceList[0].code
              : "/";
            // item.invoiceCodeExcel = Array.isArray(item.etcInvoiceList)
            //   ? item.etcInvoiceList.map(item => item.invoiceCode).join(";")
            //   : "/";
            // console.log("item.invoiceCodeExcel", item.invoiceCodeExcel);
            // item.invoiceNumExcel = Array.isArray(item.etcInvoiceList)
            //   ? item.etcInvoiceList.map(item => item.invoiceNum).join(";\n")
            //   : "/";
            console.log("item.invoiceNumExcel", item.invoiceNumExcel);
          });

          this.sumObject = response.data.sumObject;
          resolve();
        });
      });
    },
    handleDetail(row) {
      // this.$refs.checkDetail.getData(row);
    },
    handleEtcInvoiceCount(row) {
      // 处理ETC发票数量点击事件
      this.showDetail = true;
      console.log("ETC发票数量点击:", row);
    }
  }
};
</script>
<style lang="scss">
.checkList_box_wrap {
  height: calc(100vh - 160px);
  padding: 15px;
  .vxe-pager.is--loading:after {
    background-color: transparent;
  }
  position: relative;
}
</style>
<style scoped>
.checkList_total {
  position: absolute;
  right: 124px;
  top: 25px;
  font-weight: bold;
}
/* 针对微信浏览器定制滚动条 */
::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}

::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
.etc-invoice-count {
  color: #409eff;
  cursor: pointer;
}
.pay_success {
  color: green;
  font-weight: bold;
}
</style>
